import module_icon from "../../../assets/images/module_icon.png"
import component_icon from "../../../assets/images/component_icon.png"
import page_setting_icon from "../../../assets/images/page_setting_icon.png"
import module_active_icon from "../../../assets/images/module_active_icon.png"
import component_active_icon from "../../../assets/images/component_active_icon.png"
import setting_active_icon from "../../../assets/images/setting_acive_icon.png"
import {allState, bigScreenState, componentState,  } from "./menuComponent/index.js"
export default {
  menu: {
    name: "菜单",
    children: [
      {
        type: "element",
        name: "基础",
        isActive: false,
        icon: component_icon,
        activeIcon: component_active_icon,
        children: Object.keys(allState).map(key => allState[key])
      },
      {
        type: "chart",
        name: "图表",
        icon: page_setting_icon,
        activeIcon: setting_active_icon,
        isActive: false,
        children: Object.keys(bigScreenState).map(key => bigScreenState[key])
      },
      {
        type: "component",
        name: "组件",
        icon: page_setting_icon,
        activeIcon: setting_active_icon,
        isActive: false,
        children: Object.keys(componentState).map(key => componentState[key])
      },
      {
        type: "container",
        name: "收藏",
        isActive: false,
        icon: module_icon,
        activeIcon: module_active_icon,
        children: [
          {
            name: "板块容器",
            type: "empty_container",
            children: [
              {
                name: "基础容器",
                thumbnail: "http://117209pq.mh.chaoxing.com/assets/images/left_panel/icon-layout1.png",
                isActive: false
              }
            ]
          }
        ]
      }
    ],
    appId: []
  }
}
